import EditorJsParser, { BlockData } from './EditorJsParser';

/* eslint-disable class-methods-use-this, @typescript-eslint/no-unused-vars */

class EditorJsDataToTextParser extends EditorJsParser {
  protected paragraph(data: BlockData) {
    const html = super.paragraph(data);
    const element = document.createElement('div');
    element.innerHTML = html;
    const text = this.removeLineFeed(element.innerText).trim();
    if (text) {
      return `${text}\r\n\r\n`;
    }
    return '';
  }

  protected header(data: BlockData) {
    return `${this.stripTags(data.text || '')}\r\n\r\n`;
  }

  protected list(data: BlockData) {
    const arrayText = data.items?.map(
      (item, index) => `${index + 1} ${this.stripTags(item || '')}`,
    ) || [''];

    return arrayText?.join('\r\n');
  }

  protected image(data: BlockData) {
    return '';
  }

  protected raw(data: BlockData) {
    return '';
  }

  protected code(data: BlockData) {
    return '';
  }

  // eslint-disable-next-line
  protected delimeter(data: BlockData) {
    return '\r\n';
  }

  protected attaches(data: BlockData) {
    return '';
  }

  protected table(data: BlockData) {
    let rows = '';
    data.content?.forEach((row: string[]) => {
      let cells = '';
      row.forEach((cell: string) => {
        cells += `${cell}   `;
      });
      rows += `${cells}\r\n`;
    });
    return rows;
  }

  removeLineFeed(text: string) {
    return text.replace(/(\r\n)|(\n)/gi, ' ');
  }

  protected nameScriptInstructionBlock(data: BlockData) {
    return `${super.nameScriptInstructionBlock(data, true)}\r\n\r\n`;
  }
}

export default EditorJsDataToTextParser;
